import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { PublicationMobileDealershipSelectorProps } from '../../interfaces';
import styles from '../../publicationDetailMobile.module.scss';



const PublicationMobileDealershipSelector: React.FC<PublicationMobileDealershipSelectorProps> = ({
    type,
    vehicleTypeSelected,
    brand,
    brandsDealerships,
    selectedDealership,
    setSelectedDealership
}) => {
    if (type === "myPublication" || vehicleTypeSelected !== "new" || !brand) {
        return null;
    }

    return (
        <div className={styles.dealershipSelector}>
            <h3 className={styles.selectorTitle}>Elige tu concesionario de preferencia</h3>
            <FormControl fullWidth variant="outlined" className={styles.dealershipFormControl}>
                <Select
                    value={selectedDealership || ''}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        setSelectedDealership && setSelectedDealership(newValue);
                    }}
                    displayEmpty
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                    }}
                    className={styles.dealershipSelect}
                    inputProps={{
                        classes: {
                            icon: styles.selectIcon,
                        },
                    }}
                >
                    <MenuItem disabled value="">
                        <span className={styles.placeholder}>Concesionario</span>
                    </MenuItem>
                    {brandsDealerships && brandsDealerships.length > 0 ? (
                        brandsDealerships.map((dealer: any) => {
                            const dealerId = dealer.id || dealer._id;
                            const dealerName = dealer.name || 'Concesionario';
                            return (
                                <MenuItem key={dealerId} value={dealerId}>
                                    {dealerName}
                                </MenuItem>
                            );
                        })
                    ) : (
                        <MenuItem disabled>No hay concesionarios disponibles</MenuItem>
                    )}
                </Select>
            </FormControl>
        </div>
    );
};

export default PublicationMobileDealershipSelector;
